export default import.meta.glob('~~/common/aw_icons/src/header/*.svg', { query: '?raw', import: 'default', eager: true });
